import { useCallback } from 'react';
import noop from 'lodash/noop';

import { Stack } from '@lyearn/ui';
import { UserQuestionsEditorConfig } from '@/modules/user-survey/questions';
import BlockContainer from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/components/BlockContainer';
import QuestionEditorContainer from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/components/QuestionEditorContainer';
import { UpdateQuestionEntity } from '@/types/schema';

import { UserSurveyQuestionEditorProps } from './types';

const UserSurveyQuestionEditor: React.FC<UserSurveyQuestionEditorProps> = (props) => {
  const { question, onChange, viewMode, error } = props;

  const { Editor } = UserQuestionsEditorConfig[question.questionType!];

  const onUpdateNameOrDescription = useCallback(
    ({ name, description }: { name?: string; description?: string }) => {
      onChange({
        ...question,
        questionText: name !== undefined ? name : question.questionText,
        description: description !== undefined ? description : question.description,
      });
    },
    [onChange, question],
  );

  const onUpdateQuestion = useCallback(
    (questionUpdates: Partial<UpdateQuestionEntity>) => {
      onChange({ ...question, ...questionUpdates });
    },
    [onChange, question],
  );

  return (
    <Stack className="mt-[10%] w-full max-w-[54rem]" direction="col">
      <BlockContainer error={error} isSelected={true} viewMode={viewMode} onSelect={noop}>
        <QuestionEditorContainer
          isSelected={true}
          question={question}
          viewMode={viewMode}
          onUpdateQuestion={onUpdateNameOrDescription}>
          <Editor question={question} viewMode={viewMode} onChange={onUpdateQuestion} />
        </QuestionEditorContainer>
      </BlockContainer>
    </Stack>
  );
};

export default UserSurveyQuestionEditor;
